import { combineReducers } from '@reduxjs/toolkit'

import { USER_REDUCER_NAME } from './consts'
import { userReducer } from './slice'

export default combineReducers({
  [USER_REDUCER_NAME]: userReducer,
})
